import { HttpContextToken } from '@angular/common/http';

/** Opt-out of the global "Something went wrong" toast for a 404 that the caller handles itself (for example, by redirecting). */
export const SUPPRESS_NOT_FOUND_TOAST = new HttpContextToken<boolean>(() => false);
